import { Tab, Tabs } from '@material-ui/core';
import { findBenefit, getclaim, getClaimSubscription, getEvents, getPaperAndDocument } from 'app/modules/claim/service';
import { getClaimState, getEvent } from 'app/modules/claim/service/store/selectors';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getUserInfoSelector } from 'app/modules/contract/service/store/selectors';
import { uploadDocuments } from 'app/modules/document/service';
import { checkIfExistBonTransport, cleanGeolocalisationState, downloadOrGenerateBP, hideGenerateBPError, hideGeolocalisationModal, mobileAppleGeolocalise, mobileAppleGeolocationCheckAvailability, resetBonTransport } from 'app/modules/logistic/service';
import { getClaimEngineSelector, getModalInformationButton } from 'app/modules/cms/service/store/selectors';
import { DeviceType } from 'app/modules/rules/domain/Device.type';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { View } from 'app/modules/rules/domain/View';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import { getAccount } from 'app/modules/user/service/store/selectors';
import ConfComp from 'app/shared/components/common/conf-component';
import ModalGenerateBpError from 'app/shared/components/common/modal/modal-generate-bp-error';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import ContractEngineSkeleton from 'app/shared/components/skeleton/contract-engine/contract-engine';
import { IRootState } from 'app/shared/reducers';
import { Constraint } from 'app/shared/util/constraint';
import { constructBpObject, refreshScroll } from 'app/shared/util/methode-util';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import { v4 as uuidV4 } from 'uuid';
import { providerPrefix } from '../../../shared/util/constants';
import './style.scss';

const ClaimEngine = props => {

  const match: any = useRouteMatch();
  const { params } = match;
  const [menuValue, setMenuValue] = React.useState(0);
  const location: any = useLocation();
  const refHeight = useRef(null);
  const dispatchor = useDispatch();

  const viewDataitems = useSelector(getDataViewRules(View.CLAIM_ENGINE));
  const account = useSelector(getAccount);
  const claimState: any = useSelector<IRootState>(getClaimState);

  const loading: any = claimState?.loading;

  const subscriptionSelected: any = claimState?.subscriptionSelected;
  const redirect: any = claimState?.redirect;
  const listDocs: any = claimState?.listDocs;

  let claimEvent: any = useSelector<IRootState>(getEvent);
  const userInfo: any = useSelector<IRootState>(getUserInfoSelector);
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const benefitInfo: any = useSelector<IRootState>(state => state.logistic.benefitClaimResponse);
  const sellingPoint: any = useSelector<IRootState>(state => state.sellingPoint);
  const claim: any = useSelector<IRootState>(state => state.claim);
  const logistic: any = useSelector<IRootState>(state => state.logistic);
  const claimEngineCms: any = useSelector(getClaimEngineSelector);
  const [viewData, setViewData] = useState(viewDataitems?.componentDataList[0]?.sousComponentDataList);
  const constraintBP: any = useSelector<IRootState>(state => state.logistic.bonTransportConstraint.showBontransportButton);

  const {
    loading: loadingLogistic,
    loadingGeolocation,
    geolocalisation,
    geolocalisationModal,
    bonTransportError,
    bonTransportConstraint
  }: any = useSelector<IRootState>(state => state.logistic);


  const uploadClaimDocsHandler = docs => {
    dispatchor(uploadDocuments(docs));
  };

  const correspandence = key => {
    return claimEngineCms?.components_item?.find(el => el.key === key)?.label;
  };

  const history = useHistory();

  const MapAction = (action: string) => {
    let valIndex = 0;
    if (action) {
      switch (action) {
        case 'upload':
          valIndex = viewDataitems?.componentDataList[0]?.sousComponentDataList.findIndex(
            e => e.componentDataKey === 'MOBILE_ESPACE_DOCUMENT_TAB'
          );
          break;
        case 'follow':
          valIndex = viewDataitems?.componentDataList[0]?.sousComponentDataList.findIndex(
            e => e.componentDataKey === 'MOBILE_CLAIM_EVENT_TAB'
          );
          break;
        default:
          break;
      }
    }
    return valIndex;
  };

  const [files, setFiles] = useState({});
  const [openModel, setOpenModel] = useState(false);
  const [downloadBpButton, setDownloadBpButton] = useState(false);

  const uploadDocs = () => {
    const listDocss: any = Object.values(files);

    const listDocsflat = listDocss?.flat();

    if (listDocsflat.length === 0) { setOpenModel(true) };
    uploadClaimDocsHandler(
      listDocsflat?.map(el => ({
        ...el,
        subscriptionNumber: claimState.claimSelected?.subscriptionNumber,
        claimNumber: claimState.claimSelected?.claimNumber,
        userName: '',
      }))
    );
  };

  refreshScroll();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setMenuValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    setMenuValue(index);
  };

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }

  const findImei = (param: any) => {
    let imei = '';
    if (param[0] && param[0]?.details && param[0]?.details.find(e => e.refDetailTypeCode === 15).value) {
      imei = param[0]?.details.find(e => e.refDetailTypeCode === 15).value;
      return imei;
    }
  };

  const getBrand = (data: any) => {
    return (data?.damagedGoods[0] || [])?.brand;
  };

  const getModel = (data: any) => {
    return (data?.damagedGoods[0] || [])?.model;
  };

  const geolocationCheckAvailabilityDispatch = () => {
    dispatchor(
      mobileAppleGeolocationCheckAvailability(
        {
          idProvider: providerPrefix[claimState?.benefit?.benefitProvider?.code],
          subscriptionNumber: subscriptionSelected?.number,
          claimNumber: claimState.claimSelected?.claimNumber
        },
        findImei(claimState.claimSelected?.damagedGoods)
      )
    );
  };

  const sousComponentList = useMemo(() => viewDataitems?.componentDataList[0]?.sousComponentDataList, [viewDataitems]);

  useEffect(() => {
    const claimNumberState = location.state?.claimNumber || params?.claimNumber;
    if (claimNumberState) {
      dispatchor(getclaim(claimNumberState));
    }
  }, [viewDataitems, location.state]);

  useEffect(() => {
    if (viewDataitems?.dataRecoveryService?.find(service => service === 'MobileClaimEngine')) {
      dispatchor(getDocCMS('mobile_claim_engine_v2'));
    }
  }, [viewDataitems]);

  useEffect(() => {
    const claimNumberState = location.state?.claimNumber || params?.claimNumber;
    if (claimState.claimSelected?.claimNumber === claimNumberState) {
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetClaimSubscription')) {
        dispatchor(getClaimSubscription(claimState.claimSelected?.subscriptionNumber));
      }

      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetEvents')) {
        dispatchor(getEvents('CLAIM', claimState.claimSelected?.claimNumber));
      }
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetPaperAndDocument')) {
        dispatchor(getPaperAndDocument(claimState.claimSelected?.subscriptionNumber, claimState.claimSelected.claimNumber));
      }

      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetBenefit')) {
        dispatchor(resetBonTransport());
        dispatchor(findBenefit(claimState.claimSelected?.claimNumber));
      }
      const action = location.state?.action;
      if (action) {
        const indice = MapAction(action) || 0;
        setMenuValue(indice);
      }
    }
  }, [claimState.claimSelected]);

  useEffect(() => {
    if (claimState.claimSelected && bonTransportConstraint?.existBonTransport) {
      geolocationCheckAvailabilityDispatch();
    }
  }, [claimState.claimSelected, bonTransportConstraint])

  useEffect(() => {
    if (claimState.claimSelected) {
      const rulesContextCode: RulesContext = {
        key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
        entryDataRules: { view: View.CLAIM_ENGINE, productCode: claimState.claimSelected?.product?.code, deviceType: DeviceType.MOBILE },
      };
      dispatchor(getDataView(rulesContextCode));
    }
  }, [claimState?.claimSelected]);

  useEffect(() => {
    const claimNumberState = location.state?.claimNumber || params?.claimNumber;
    if (claimState?.benefit?.claimNumber === claimNumberState) {
      dispatchor(
        checkIfExistBonTransport({
          benefitProcess: claimState?.benefit?.benefitProcess?.code,
          benefitProvider: claimState?.benefit?.benefitProvider?.code,
          deviceDeposite: claimState.claimSelected?.details.find(e => e.refDetailTypeCode === 174)?.value,
          benefitCover: claimState?.claimSelected?.cover?.code,
          benefitAction: claimState?.benefit?.benefitAction?.code,
          benefitStatus: claimState?.benefit?.benefitStatus?.code,
          claimStatus: claimState?.claimSelected?.claimStatus?.code

        })
      );
    }
  }, [claimState?.benefit]);

  useEffect(() => {
    if (redirect) {
      history.push(`/home`);
    }
  }, [redirect]);

  useEffect(() => {
    if (listDocs && listDocs?.length === 0) {
      setViewData(viewDataitems?.componentDataList[0]?.sousComponentDataList.filter(item => item.componentDataKey !== 'MOBILE_ESPACE_DOCUMENT_TAB'));
    } else {
      setViewData(viewDataitems?.componentDataList[0]?.sousComponentDataList);
    }
  }, [listDocs, viewDataitems]);

  const geolocationServiceDispatch = () => {
    dispatchor(
      mobileAppleGeolocalise(
        {
          idProvider: providerPrefix[claimState?.benefit?.benefitProvider?.code],
          subscriptionNumber: subscriptionSelected?.number,
          claimNumber: claimState.claimSelected?.claimNumber
        },
        findImei(claimState.claimSelected?.damagedGoods)
      )
    );
  };

  const cleanGeolocalisationStateDispatch = () => {
    dispatchor(cleanGeolocalisationState());
  }

  const bonTransportServiceDispatch = () => {
    const eventBt = claimEvent.find(event => event.code === 9);
    let trakingNumber = '';
    if (eventBt) {
      trakingNumber = constructBpObject(eventBt?.generationLink, {})?.trackingNumber;
    }
    dispatchor(
      downloadOrGenerateBP(
        {
          idProvider: providerPrefix[claimState?.benefit?.benefitProvider?.code],
          claimNumber: claimState.claimSelected.claimNumber,
          downloadBp: trakingNumber ? true : false,
          subscriptionNumber: subscriptionSelected?.number,
          sequenceNumber: claimState?.benefit?.sequence,
          type: providerPrefix[claimState?.benefit?.benefitProvider?.code],
          mail: subscriptionSelected?.subscriber?.email,
          operationType: 'FIND',
          codePointRelais: claimState.claimSelected?.details.find(e => e.refDetailTypeCode === 1310)
            ? claimState.claimSelected?.details?.find(e => e.refDetailTypeCode === 1310)?.value
            : '',
          trackingNumber: trakingNumber,
        },
        findImei(claimState.claimSelected?.damagedGoods),
        subscriptionSelected?.externalRef,
        getBrand(claimState?.claimSelected)

      )
    );
  };

  const goCompDetails = compName => {
    const valIndex = sousComponentList?.findIndex(e => e?.componentDataKey === compName);
    setMenuValue(valIndex);
  };
  function getConstrante(constraint, confValue) {
    return Constraint(
      constraint,
      { accountState: null, sellingPointState: sellingPoint, claimState: claim, docState: listDocs, logisticState: logistic },
      confValue
    );
  }

  const getPropsByCompKey = (compKey: any) => {
    switch (compKey) {
      case 'MOBILE_RECAP_TAB':
        return {
          ...claimState.claimSelected,
          ...claimState.claimCriteria,
          handleChangeIndex,
          geolocationServiceDispatch,
          cleanGeolocalisationStateDispatch,
          geolocalisation,
          bonTransportServiceDispatch,
          benefitInfo,
          downloadBpButton,
          loadingGeolocation,
          claimEngineCms,
          listDocs,
          laodingClaim: loadingLogistic,
          goCompDetails,
          getConstrante,
        };
      case 'MOBILE_CLAIM_EVENT_TAB':
        {
          if (!constraintBP) {
            claimEvent = claimEvent.filter((i) => i.code !== 9);
          }
          return { claimEvent, generateBonTransport: bonTransportServiceDispatch, claimEngineCms };
        }
      case 'MOBILE_ESPACE_DOCUMENT_TAB':
        return {
          data: claimState.claimSelected,
          uploadClaim: uploadClaimDocsHandler,
          subscriptionSelected,
          userInfo,
          itemToUpload: listDocs,
          files,
          setFiles,
          documentInfoCms: claimEngineCms?.claim_document_items,
          dataConf: viewDataitems?.componentDataList[0]?.sousComponentDataList.findIndex(
            e => e.componentDataKey === 'MOBILE_ESPACE_DOCUMENT_TAB'
          ),
        };
      default:
        break;
    }
  };

  return (
    <>
      {loading ? (
        <ContractEngineSkeleton />
      ) : (
        <>
          <div className="avatar-header-container">
            <div className="avatar-header" ref={refHeight}>
              <AvatarWithBadge avatar={avatar} title={[claimEngineCms.avatar_text + claimState.claimSelected?.claimNumber]} previousLink={'/claims'} />
            </div>
          </div>
          <Tabs className="claim-engine-mobile-header" value={menuValue} onChange={handleChange} variant={viewData?.length <= 2 ? "fullWidth" : "scrollable"} scrollButtons="auto">
            {(viewData || []).map((item, index) => {
              return (
                <Tab className="Tab-bg-color" key={uuidV4()} label={correspandence(item.componentDataKey)} {...a11yProps(index)} />
              );
            })}
          </Tabs>
          <div className="scroll-y" style={{ height: `calc(100% - ${refHeight.current?.clientHeight + 140}px)`, overflowY: 'scroll' }}>
            <SwipeableViews axis={'x'} index={menuValue} onChangeIndex={handleChangeIndex}>
              {(viewData || []).map((item, index) => {
                return (
                  <React.Fragment key={uuidV4()}>
                    {menuValue === index &&
                      <div
                        className="p-2 d-flex h-100"
                        role="tabpanel"
                        hidden={menuValue !== index}
                        id={`full-width-tabpanel-${index}`}
                        aria-labelledby={`full-width-tab-${index}`}
                      >
                        <ConfComp
                          code={item.componentDataKey}
                          listCode={sousComponentList}
                          props={getPropsByCompKey(item.componentDataKey)}
                        />
                      </div>
                    }
                  </React.Fragment>
                );
              })}
            </SwipeableViews>
            <div className="pagination d-flex justify-content-center">
              {(viewData || []).map(
                (item, index) =>
                  <div key={uuidV4()} onChange={() => handleChange} className={`border-pag ${index === menuValue ? 'active' : ''}`}>
                    <span className="item-pag" />
                  </div>
              )}
            </div>
          </div>
        </>
      )}
      <ModalGenerateBpError
        message={[claimEngineCms?.claim_recap_items?.modal_generate_bp_error]}
        modal={bonTransportError}
        setModal={() => dispatchor(hideGenerateBPError())}
        txtContactUsButton={claimEngineCms?.claim_recap_items?.modal_degeolocalisation_error_contact_button}
        hideClose={true}
        contactUsButtonAction={() => history.push("/contact")}
      />
      <ModalGenerateBpError
        message={[claimEngineCms?.claim_recap_items?.modal_geolocation_check_info]}
        modal={geolocalisationModal}
        setModal={() => dispatchor(hideGeolocalisationModal())}
      />
    </>
  );
};

export default ClaimEngine;
